import React, { useState, useEffect } from 'react';
import { Clock, Crown, Sparkles } from 'lucide-react';
import { Button } from './ui/button';

const TrialBanner = ({ trialInfo, onUpgrade }) => {
  const [timeLeft, setTimeLeft] = useState('');

  useEffect(() => {
    if (!trialInfo || !trialInfo.is_trial) return;

    const calculateTimeLeft = () => {
      const hours = trialInfo.hours_remaining || 0;
      const days = trialInfo.days_remaining || 0;

      if (days > 0) {
        return `${days} day${days !== 1 ? 's' : ''} left`;
      } else if (hours > 0) {
        return `${hours} hour${hours !== 1 ? 's' : ''} left`;
      } else {
        return 'Ending soon';
      }
    };

    setTimeLeft(calculateTimeLeft());

    // Update every minute
    const interval = setInterval(() => {
      setTimeLeft(calculateTimeLeft());
    }, 60000);

    return () => clearInterval(interval);
  }, [trialInfo]);

  if (!trialInfo || !trialInfo.is_trial || trialInfo.trial_expired) {
    return null;
  }

  const daysLeft = trialInfo.days_remaining || 0;
  const isUrgent = daysLeft <= 2;

  return (
    <div className={`fixed top-20 left-0 right-0 w-full z-40 ${isUrgent ? 'bg-gradient-to-r from-pink-500 to-purple-600' : 'bg-gradient-to-r from-blue-500 to-purple-500'} text-white shadow-lg`}>
      <div className="max-w-7xl mx-auto px-3 py-2 sm:px-6 sm:py-3 lg:px-8">
        <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-2 sm:gap-3">
          <div className="flex items-center gap-2 sm:gap-3 flex-1 w-full">
            <div className={`flex-shrink-0 flex items-center justify-center w-8 h-8 sm:w-10 sm:h-10 rounded-full ${isUrgent ? 'bg-white/20 animate-pulse' : 'bg-white/20'}`}>
              {isUrgent ? (
                <Clock className="w-4 h-4 sm:w-5 sm:h-5" />
              ) : (
                <Crown className="w-4 h-4 sm:w-5 sm:h-5" />
              )}
            </div>
            <div className="flex-1 min-w-0">
              <p className="font-semibold text-xs sm:text-sm md:text-base truncate">
                {isUrgent ? '⏰ Trial Ending Soon!' : '🎉 Growth Trial Active!'}
              </p>
              <p className="text-[10px] sm:text-xs md:text-sm opacity-90">
                {isUrgent ? (
                  <>
                    <strong>{timeLeft}</strong> left
                  </>
                ) : (
                  <>
                    <strong>{timeLeft}</strong> of premium features
                  </>
                )}
              </p>
            </div>
          </div>

          <Button
            onClick={onUpgrade}
            className={`
              w-full sm:w-auto px-4 sm:px-6 py-1.5 sm:py-2 rounded-full font-semibold text-xs sm:text-sm flex-shrink-0
              ${isUrgent 
                ? 'bg-white text-pink-600 hover:bg-gray-100' 
                : 'bg-white/20 hover:bg-white/30 backdrop-blur-sm'
              }
              transition-all shadow-lg
            `}
          >
            <Sparkles className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2 inline" />
            {isUrgent ? 'Keep Features' : 'Upgrade'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default TrialBanner;
